import { Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Stack, Text } from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'
import { SiQuantcast } from 'react-icons/si';
import { InventoryAcc, QtyUpdateRequest, QtyUpdateTransfer, ReturnSupervisor } from '../Utils/ApiCalls';
import Button from './Button';
import Input from './Input'
import { MdReviews } from 'react-icons/md';

export default function ReturnToSupervisor({ isOpen, onOpen, onClose, id }) {

    const [Payload, setPayload] = useState({
        remark: ""
    });

    const [Loading, setLoading] = useState(false);

    

    const handleUpdate = (e) => {
        setPayload({ ...Payload, [e.target.id]: e.target.value })
    }

    
    const [errorMsg, setErrorMsg] = useState({
        status: false,
        msg: ""
    });

    const [SuccessMsg, setSuccessMsg] = useState({
        status: false,
        msg: "sdfgvhbnm"
    });

    const UpdateRequest = async ()=>{
        try {
            setLoading(true)
            let result =  await ReturnSupervisor(Payload,id);
           
            if (result.status == true) {
                setLoading(false)
                setSuccessMsg({
                    status: true,
                    msg: "Returned successfully"
                })

                setPayload({
                   remark: ""
                })

                setTimeout(() => {
                    setSuccessMsg({
                        status: false,
                        msg: ""
                    })
                    onClose()
                }, 3000);

            } else {
                setLoading(false)
                setErrorMsg({
                    status: true,
                    msg: result.msg
                })

                setTimeout(() => {
                    setErrorMsg({
                        status: false,

                    })
                }, 3000);

            }


        } catch (e) {

            setLoading(false)
            setErrorMsg({
                status: true,
                msg: e.message
            })
            setTimeout(() => {
                setErrorMsg({
                    status: false,
                    msg: e.message
                })
            }, 5000);
            console.error('Error:', e.message);
        }

    }

    useEffect(() => {
       
    }, [isOpen]);

    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader textTransform={"capitalize"}>Return to Supervisor</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <Stack spacing={"15px"}>
                        <Input leftIcon={<MdReviews/>} iconColor="black" labelBg='#fff' label='Review' id="remark" type='text' value={Payload.remark} val={Payload.remark != "" ? true : false} onChange={handleUpdate} />

                    </Stack>

                    <Button mt="14px" isLoading={Loading}
                        disabled={Payload.remark != "" ? false : true}
                        onClick={UpdateRequest} background="red">Return
                    </Button>



                    
                    {
                        errorMsg.status && (
                            <Text mt={"10px"} color="red" textAlign="center">{errorMsg.msg}</Text>
                        )
                    }

                    {
                        SuccessMsg.status && (
                            <Text mt={"10px"} color="green" textAlign="center">{SuccessMsg.msg}</Text>
                        )
                    }
                </ModalBody>

                <ModalFooter>


                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}
